/* index.js */

"use strict";

// const _ = require("lodash");
// const Button = require("@gluenetworks/steve_ui_core").Control.Action.Button;

// const { labelByTypeData } = require("../CustomFieldsConstants");

module.exports = {
    conditionalFormatter,
    countFormatter,
    sumFormatter,
    averageFormatter,
    actionIconsFormatter
};

function conditionalFormatter(row, cell, value, columnDef, dataContext) {
    let p = document.createElement("p");
    if (value || value === 0 || value === false) {
        if (dataContext[columnDef.field + ".highlight"]) {
            p.style.color = dataContext[columnDef.field + ".highlight"];
        }
        p.classList.add("conditional");
        p.innerHTML = value;
    }
    return p.outerHTML;
}

function countFormatter(totals, columnDef /*, grid*/) {
    let val = totals.count && totals.count[columnDef.field];
    if (val) {
        return "Count: " + Math.round(parseFloat(val) * 100) / 100;
    }
    return "";
}

function sumFormatter(totals, columnDef /*, grid*/) {
    let p = document.createElement("p");
    let val = totals.sum && totals.sum[columnDef.field];
    if (val) {
        p.innerHTML = "Sum " + Math.round(parseFloat(val) * 100) / 100;
    } else {
        p.innerHTML = "Sum 0";
    }
    p.classList.add("right");
    return p.outerHTML;
}

function averageFormatter(totals, columnDef /*, grid*/) {
    let p = document.createElement("p");
    let val = totals.avg && totals.avg[columnDef.field];
    if (val) {
        p.innerHTML = "Avg " + Math.round(parseFloat(val) * 100) / 100;
    } else {
        p.innerHTML = "Avg 0";
    }
    p.classList.add("right");
    return p.outerHTML;
}

function actionIconsFormatter(row, cell, value, columnDef, dataContext) {
    let container = document.createElement("div");
    container.classList.add("results-action-container");

    const devDetIcon = document.createElement("actionable-icon-gl");
    devDetIcon.dataset.icon = "configdrift.device_details";
    devDetIcon.dataset.device = dataContext.devId;
    devDetIcon.setAttribute("title", "Device details");
    container.appendChild(devDetIcon);

    const devConfIcon = document.createElement("actionable-icon-gl");
    devConfIcon.dataset.icon = "configdrift.eye";
    devConfIcon.dataset.device = dataContext.devId;
    devConfIcon.setAttribute("title", "Device configuration");
    container.appendChild(devConfIcon);

    // const captureIcon = document.createElement("actionable-icon-gl");
    // captureIcon.dataset.icon = "configdrift.snapshot";
    // captureIcon.dataset.device = dataContext.devId;
    // captureIcon.setAttribute("title", "Capture snapshot");
    // container.appendChild(captureIcon);

    return container.outerHTML;
}
